// extracted by mini-css-extract-plugin
export var schemaContentBlock = "schema-content-block-module--schemaContentBlock--779d8";